import { QRCodeSVG } from "qrcode.react";
import { Copy } from "lucide-react";
import { toast } from "sonner";
import { formatINR } from "@/lib/lamka";
import { upiParams } from "@/lib/order";

export const UpiPayment = ({ vpa, sellerName, amount, note }) => {
  const p = upiParams({ vpa, name: sellerName, amount, note });
  const links = [
    { id: "gpay", label: "Pay with GPay", href: `tez://upi/pay?${p}` },
    { id: "phonepe", label: "Pay with PhonePe", href: `phonepe://pay?${p}` },
    { id: "other", label: "Other UPI app", href: `upi://pay?${p}` },
  ];

  return (
    <div data-testid="upi-payment" className="space-y-6">
      <p className="eyebrow">Step 1 · Pay {formatINR(amount)}</p>
      <div className="grid sm:grid-cols-[auto_1fr] gap-6 items-center bg-white border border-[#C5A059]/25 p-5 sm:p-6">
        <div className="bg-white p-3 border border-[#0F0F0F]/10 justify-self-center" data-testid="upi-qr-code">
          <QRCodeSVG value={`upi://pay?${p}`} size={168} fgColor="#0F0F0F" />
        </div>
        <div className="space-y-3 min-w-0">
          <p className="text-sm text-[#3f3f46]">Scan with any UPI app, or tap a button below on your phone.</p>
          <div className="flex items-center gap-2">
            <span data-testid="upi-vpa" className="font-mono text-sm bg-[#F5EFE6] px-3 py-2 truncate">{vpa}</span>
            <button
              data-testid="upi-copy-button"
              aria-label="Copy UPI ID"
              onClick={() => navigator.clipboard ? navigator.clipboard.writeText(vpa).then(() => toast("UPI ID copied")).catch(() => {}) : toast(vpa)}
              className="p-2 border border-[#0F0F0F]/20 hover:border-[#0F0F0F]"
            >
              <Copy className="h-4 w-4" />
            </button>
          </div>
          <p data-testid="upi-amount" className="font-mono text-xs uppercase tracking-[0.2em] text-[#71717A]">Amount: {formatINR(amount)}</p>
        </div>
      </div>
      <div className="grid sm:grid-cols-3 gap-3">
        {links.map((l) => (
          <a key={l.id} data-testid={`upi-link-${l.id}`} href={l.href} className="text-center border border-[#0F0F0F] py-3 text-xs tracking-[0.2em] uppercase transition-colors hover:bg-[#0F0F0F] hover:text-[#C5A059]">
            {l.label}
          </a>
        ))}
      </div>
    </div>
  );
};
